var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_84_1",
    "data-name": "Component 84 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3420",
    "data-name": "Path 3420",
    d: "M9.5,0A9.5,9.5,0,1,0,19,9.5,9.5,9.5,0,0,0,9.5,0Z",
    fill: "#f4f6f8",
    opacity: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "menu-icon",
    d: "M14.249,2.5A2.378,2.378,0,1,1,19,2.5a2.378,2.378,0,1,1-4.751,0Zm-7.124,0A2.44,2.44,0,0,1,9.5,0a2.44,2.44,0,0,1,2.375,2.5A2.44,2.44,0,0,1,9.5,5,2.44,2.44,0,0,1,7.125,2.5ZM0,2.5A2.44,2.44,0,0,1,2.375,0,2.44,2.44,0,0,1,4.751,2.5,2.44,2.44,0,0,1,2.375,5,2.44,2.44,0,0,1,0,2.5Z",
    transform: "translate(6.905 19) rotate(-90)",
    fill: "#758ca1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOutlined);
export default __webpack_public_path__ + "static/media/more-outlined.c0a658fa.svg";
export { ForwardRef as ReactComponent };